export default "__VITE_ASSET__Bpl3oLFj__"